import { inject, Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanMatch,
  Route,
  UrlTree,
} from '@angular/router';
import {
  AuthService,
  SET_PASSWORD_URL,
  TokenService,
} from 'libs/core/src/public-api';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanMatch {
  private router = inject(Router);
  private tokenService = inject(TokenService);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canAccess(route, state);
  }

  canMatch(route: Route) {
    return this.canAccess(route);
  }

  canAccess(
    route: ActivatedRouteSnapshot | Route,
    state?: RouterStateSnapshot,
  ): boolean | UrlTree {
    const isRoleAllowed =
      !route.data?.['roles'] ||
      route.data['roles']?.includes(this.authService.user()?.role);
    if (this.tokenService.isAuthenticated() && isRoleAllowed) {
      if (this.authService.mustSetPassword()) {
        return this.router.parseUrl(SET_PASSWORD_URL);
      }
      return true;
    }
    if (state) {
      this.router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
    }
    return false;
  }
}
